<template>
<div>
    <div class="maren-sol">
        <el-container class="d-flex-column">
        <h1>Awards & <span class="d-block">Events</span></h1>
        <p>The main goal of maren solutions is to encourage the employees  <span class="d-block"> and ensuure they are secured and feel stress- free, We do have </span> our unique activities to motivate the employees and are proud<span class="d-block"> to say that we belong to 100% employee friendly company category</span></p>
        <ul class="newlist">
          <li>Employee of the month</li>
          <li>Employee of the year</li>
          <li>100% attendance</li>
          <li>Star performer of the week </li>
          <li>Punctuality award</li>
          <li>Team outings</li>
        </ul>
        </el-container>
    </div>
    <!--<el-container class="d-flex-column p-tb50">
        <h2>Award function</h2>
        <el-carousel :interval="5000" arrow="always">
            <el-carousel-item >
                <div class="awards-slide">
                    <img src="../../../public/img/awards/awards.png" alt="awards" class="awards-img" >
                    <div class="cont">
                        <img src="../../../public/img/awards/oval.svg" alt="awards" width="100" class="oval" >
                        <img src="../../../public/img/awards/rectangle.svg" alt="awards" width="100" class="rectangle" >
                        <h3>Best employee award function</h3>
                        <p>maren solution is a product-based software compay known for intuitive design, easy to use cutom user interface and creative solutions. The company employees a pool of strong and experienced developers, designers and analyst</p>
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item >
                <div class="awards-slide">
                    <img src="../../../public/img/awards/awards.png" alt="awards" class="awards-img" >
                    <div class="cont">
                        <img src="../../../public/img/awards/oval.svg" alt="awards" width="100" class="oval" >
                        <img src="../../../public/img/awards/rectangle.svg" alt="awards" width="100" class="rectangle" >
                        <h3>Best employee award function</h3>
                        <p>maren solution is a product-based software compay known for intuitive design, easy to use cutom user interface and creative solutions. The company employees a pool of strong and experienced developers, designers and analyst</p>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
    </el-container>--->
    <el-container class="d-flex-column p-t50">
    <el-row :gutter="30" class="careers-grid">
            <el-col :span="12">
                <h2>Company Culture</h2>
                <p>We care about our employees and their personal life. We ensure every employee in our organisation maintains healthy work-life balance.  We follow right mindedness corporate ethics and adhere to  zero politics atmosphere.
We listen, care and react to our employees concerns and feedbacks. We also have friday fun activites to burn out the stress out the employees.</p>
            </el-col>
            <el-col :span="12">
                <img src="../../../public/img/careers/company-culture.png" alt="Careers" class="img-responsive" />
            </el-col>
        </el-row>
    </el-container>
</div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
  export default {
  watch:{
    scobj:{
      immediate:true,
      deep: true,
      handler(){
        if(this.scobj){
          this.scobj = false
          var element = this.$refs['flightRef'];
          var top = element.offsetTop;
          window.scrollTo(0, top);
        }
      }
    }
  },
    computed: mapState(['currentLanguage']),
    title () {
      return this.currentLanguage == 'en' ? '' : ''
    },
    components:{  },
    data() {
      return {
        }
      },
      methods: {
        toggleBodyClass(addRemoveClass, className) {
          const el = document.body;

          if (addRemoveClass === 'addClass') {
            el.classList.add(className);
          } else {
            el.classList.remove(className);
          }
        },
      },
        mounted() {
          this.toggleBodyClass('addClass', 'awards');
        },
        destroyed() {
          this.toggleBodyClass('removeClass', 'awards');
        }
    };
</script>


// WEBPACK FOOTER //
// AwardsEvents.vue